import { ClientObject, ClientObjectProperty, PropertyInit } from '../common/clientObject';
import { RequestType, ValueHolder, ValueType } from '../comObject';
import { XlWindowState } from './windowState.enum';

export class Window extends ClientObject implements PropertyInit {
    private properties = this.clientObjectInitPropsInfo({
        windowState: { propertyName: 'windowState', name: 'WindowState' },
    });

    public getPropertyInitializers(): Map<keyof Window, () => void> {
        return new Map<keyof Window, () => void>(
            Object.values(this.properties).map(({ propertyName, name }) => [
                propertyName,
                (): void =>
                    this.reference.request({
                        type: RequestType.GetProperty,
                        cacheName: propertyName,
                        name,
                    }),
            ]),
        );
    }

    public get windowState(): XlWindowState {
        return this.reference.getValue<XlWindowState>(this.properties.windowState.propertyName).value;
    }

    public set windowState(value: XlWindowState) {
        this.setProperty(this.properties.windowState, { type: ValueType.Integer, value });
    }

    private setProperty<T>(property: ClientObjectProperty<Window>, valueHolder: ValueHolder<T>): void {
        const { propertyName, name } = property;

        this.reference.request({
            type: RequestType.SetProperty,
            cacheName: propertyName,
            name,
            args: [valueHolder],
        });
    }
}
